module.exports = __webpack_public_path__ + "img/GAME_BADUK2.ed31cdfe.jpg";